/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ahu_History_Key_Supplyairactualsetpoint3Inputs */



/**
* | output |
* | --- |
* | "Supply air actual setpoint" |
*
* @param {Ahu_History_Key_Supplyairactualsetpoint3Inputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
const ahu_history_key_supplyairactualsetpoint3 = /** @type {((inputs?: Ahu_History_Key_Supplyairactualsetpoint3Inputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ahu_History_Key_Supplyairactualsetpoint3Inputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("Supply air actual setpoint")
	return /** @type {LocalizedString} */ ("Consigne air soufflé")
});
export { ahu_history_key_supplyairactualsetpoint3 as "ahu_history_key_supplyAirActualSetpoint" }